<script setup>
import { FunctionPlot, Graph } from '@ksassnowski/vueclid';

defineProps({
    graph: {
        type: Object,
        required: false,
    },
    elements: {
        type: Array,
        required: true,
        validator(value) {
            return value.length > 0;
        },
    },
});

const defaults = {
    n4: 0,
    n3: 0,
    n2: 0,
    n1: 0,
    n0: 0,
    d0: 1,
};

const theFunction = (element) => {
    const v = {
        n4: element.n4 ?? defaults.n4,
        n3: element.n3 ?? defaults.n3,
        n2: element.n2 ?? defaults.n2,
        n1: element.n1 ?? defaults.n1,
        n0: element.n0 ?? defaults.n0,
        d0: element.d0 ?? defaults.d0,
    };

    return (x) => {
        return (v.n4 * Math.pow(x, 4) + v.n3 * Math.pow(x, 3) + v.n2 * Math.pow(x, 2) + v.n1 * x + v.n0) / v.d0;
    };
};
</script>

<template>
    <Graph :domain-x="graph?.domainX" :domain-y="graph?.domainY" :origin="graph?.origin" :grid="graph?.grid">
        <FunctionPlot
            v-for="element in elements.filter((e) => e.type === 'function')"
            :function="theFunction(element)"
            :line-width="element.lineWidth"
            :color="element.color"
            :domain="element.domain"
        />
    </Graph>
</template>
